import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

import { Ingredient, IngredientsApiModel } from '../model';

@Injectable({
  providedIn: 'root',
})
export class IngredientsService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  getIngredients(): Observable<Ingredient[]> {
    return this.http
      .get<IngredientsApiModel>(`${this.baseUrl}ingredient`)
      .pipe(map((result) => result.ingredients));
  }
}
